import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";

import "./AddFunctionality.html";

import "../FindAddFunctionality/FindAddFunctionalityComponent";

import AddFunctionalityComponentController from "./AddFunctionalityComponentController";

export class AddFunctionalityComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = AddFunctionalityComponentController;
        this.templateUrl =
            "/App/Components/EquipmentType/EquipmentFunctionalities/AddFunctionality/AddFunctionality.html";
    }
}

module("mmManagePortal").component("irAddEquipmentFunctionality", new AddFunctionalityComponent());
